// extracted by mini-css-extract-plugin
module.exports = {"container":"SprinkrlPlaceholder_container__EV_QL","title":"SprinkrlPlaceholder_title__vzjQj"};